/** @jsx jsx */
import { jsx } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../sanityConfig";
import { getGatsbyImageData } from "gatsby-source-sanity";
import PortableTextComponent from "../serializers/portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";

const Hero = ({ value }) => {
  const gatsbyImageData = getGatsbyImageData(
    value.image,
    { maxWidth: 1100 },
    sanityConfig
  );
  return (
    <div id={value.id ? value.id : ""}>
      <Container>
          <div
            sx={{
              display: "grid",
              gridColumnGap:["0px", "0px", "50px"],
              gridTemplateColumns: ["100%", "100%", "53% 1fr"],
              padding: ["70px 0px 70px 0px","70px 0px 70px 0px","145px 0px 145px 0px"],
            }}
          >

              <h1
                sx={{
                  fontSize: ["2.75rem", "3.5rem"],
                  margin: "0px 0px 10px 0px",
                  lineHeight: "3.4rem",
                  gridColumn:["1/3","1/3","1/2"],
                  maxWidth:["100%", "100%", "600px"],
                }}
              >
                {value.title}
              </h1>
              <div
                sx={{
                  color: "textGray",
                  fontSize: "body",
                  lineHeight: "2.2rem",
                  gridColumn:["1/3","1/3","1/2"],
                  gridRow:["3","3", "2"],
                  maxWidth:["100%", "100%", "600px"],
                  ".cta": {
                    lineHeight: "1.5",
                    marginTop:"20px",
                  },
                  p:{
                    margin:"10px 0px",
                  }
                }}
                className="hero-copy-container"
              >
                <PortableText
                  value={value.body}
                  components={PortableTextComponent}
                />
              </div>

            <div
              className="hero-image-container"
              sx={{
                // maxWidth: ["100%", "100%", "480px"],
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent:"flex-end",
                gridColumn:["1/3","1/3","2"],
                gridRow:["2","2", "1/3"],
                marginBottom:["30px", "30px", "0px"],
                marginTop:["60px", "60px", "0px"],

                ".gatsby-image-wrapper": {
                  width: "100%",
                  overflow: "visible",
                  maxWidth:["100%", "100%", "480px"],
                  "> div": {
                    width: "100%",
                    maxWidth: "100% !important",
                  },
                },
                img: {
                  width: "100%",
                  height: "auto",
                },
              }}
            >
              <GatsbyImage
                sx={{
                  position: ["relative", "relative", "absolute"],
                }}
                image={gatsbyImageData}
              />
            </div>
          </div>
      </Container>
    </div>
  );
};

export default Hero;
